import React from 'react';
import { Transition, Dialog } from '@headlessui/react';
import { useState, useCallback, Fragment } from 'react';
import { Block, BlockHero, Section } from './ContentBlocks';
import { navigate } from 'gatsby-plugin-intl';

export const CardRenderer = ({
  block,
  onClick,
}: {
  block: Block;
  onClick: () => void;
}) => (
  <div
    onClick={onClick}
    key={block.id}
    className="flex cursor-pointer flex-col overflow-hidden sm:h-56 sm:flex-row"
  >
    <BlockHero
      block={block}
      className="mb-4 aspect-[5/3] flex-initial rounded-lg sm:mr-4 sm:aspect-square lg:aspect-[3/4]" //group-hover:shadow-lg
    />
    <div className="flex-1">
      {!!block.heading && <h4 className="mb-0 font-medium">{block.heading}</h4>}
      {!!block.subheading && (
        <h5 className="my-0 font-medium text-primary-700 opacity-90">
          {block.subheading}
        </h5>
      )}
      <p className="prose line-clamp-4 mt-6 text-base text-gray-500">
        {block.body.childMarkdownRemark.excerpt}
      </p>
    </div>
  </div>
);

export const CardSection = ({ section }: { section: Section }) => {
  const [open, setOpen] = useState(false);
  const [selectedContent, setSelectedContent] = useState(null);

  const onDismiss = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <div className="grid grid-cols-1 gap-12 py-2 lg:grid-cols-2">
      {section.blocks.map((block) =>
        CardRenderer({
          block,
          onClick: () => {
            if (block.link) {
              navigate(`${block.url}#main`);
            } else {
              setSelectedContent(block);
              setOpen(true);
            }
          },
        })
      )}

      <Transition appear show={open} as={Fragment}>
        <Dialog
          onClose={onDismiss}
          className=" fixed inset-0 z-10 overflow-y-auto"
        >
          <div className="flex min-h-screen items-center justify-center backdrop-blur-[1px] ">
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              {!!selectedContent && (
                <div className="prose relative m-6 max-w-prose rounded-lg bg-white p-4">
                  <Dialog.Title className="my-2 text-2xl font-medium">
                    {selectedContent.heading}
                    {/* still need subheading here */}
                  </Dialog.Title>
                  <BlockHero
                    block={selectedContent}
                    className="float-left mr-4 mb-4 aspect-square h-48 rounded"
                  />
                  <p
                    className="text-md text-justify text-gray-700 "
                    dangerouslySetInnerHTML={{
                      __html: selectedContent.body.childMarkdownRemark.html,
                    }}
                  />
                </div>
              )}
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};
